{
  "logoAlternateText": "Pekao Guarantees",
  "navbar": {
    "links": {
      "guaranteeOrders": "Orders",
      "styleGuide": "Style guide"
    }
  },
  "topbar": {
    "links": {
      "settings": {
        "notifications": "Notification settings"
      }
    }
  }
}
